export class AddData {
    constructor(args = {}) {
        const {width, height, ratio} = args;
        /** @private */
        this.project = Laravel.activeProject;
        this.name = '';
        this.label = this.customResolution();
        this.width = width;
        this.height = height;
        this.format = ratio;
        this.tags = [];
        this.useLayer = false;
        this.strictModeTags = false;
        this.dynamicAutoremove = false;
    }

    customResolution() { return 'custom-resolution'; }

    update(property, value) {
        // console.log('Changed', property, value);
        if (property === 'label' && value !== this.customResolution()) {
            const [width, height] = value.split('|');
            this.width = +(width);
            this.height = +(height);
            this.format = aspectRatio(width, height);
        }
        if (property === 'useLayer' && this.label === this.customResolution()) {
            this.useLayer = false;
        }
        if (property === 'height') {
            this.format = aspectRatio(this.width, value);
        }
        if (property === 'width') {
            this.format = aspectRatio(value, this.height);
        }
        this[property] = value;
    }

    validate() {
        return !!this.name && !!this.height && !!this.width && this.height < 65536 && this.width < 65536;
    }

    prepareDataForSave(tags) {
        const data =  _.cloneDeep(this);
        data.tags = this.tags.map(tagName => {
            return tags.find(tag => tag.name === tagName).id;
        });
        return data;
    }
}
